import { render, staticRenderFns } from "./Blocker.vue?vue&type=template&id=137db6ce&scoped=true&"
import script from "./Blocker.vue?vue&type=script&lang=js&"
export * from "./Blocker.vue?vue&type=script&lang=js&"
import style0 from "./Blocker.vue?vue&type=style&index=0&id=137db6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137db6ce",
  null
  
)

export default component.exports